export const STALE_TIME_10_MINUTES_IN_MS = 1000 * 60 * 10
export const STALE_TIME_INFINITY = Infinity

export const DEBOUNCE_TIME_500_MS = 500
